import { EventEmitter, Injectable } from '@angular/core';
import { ZONE } from '../zone/zone.service';

@Injectable({
  providedIn: 'root'
})
export class WardService {

  is_display_ward_register_component = false;
  wardUpdate = new EventEmitter<ZONE>();

  downloadWard = new EventEmitter<boolean>();

  private _ward_data: WARD = null;
  constructor() { }

  set set_ward_data(ward) {
    this._ward_data = ward;
  }

  get get_ward_data() {
    return this._ward_data;
  }
}

export interface WARD {
  id: number;
  name: string;
}
